import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CategoryListBody from "components/AdministrationComponents/CategoryComponents/CategoryListBody/CategoryListBody";

const CategoryList = () => {
  useEffect(() => {
    document.title = "Administration | Categories";
  }, []);

  return (
    <main id="app">
      <Header moduleName="administration" />
      <CategoryListBody />
    </main>
  );
};

export default CategoryList;
